module.exports = __webpack_public_path__ + "img/plate01_04.71d133a2.png";